export default function SourceConnectIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 57.6 40.8"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M17.3,19.3c-0.4-0.3-0.9-0.6-1.5-0.9c-2.1-1-4.3-1.9-6.3-3.3c-1.3-0.9-2.4-2.1-2.7-3.7 c0.1-1.9,1.3-3,3.1-3.6c0.7-0.3,1.5-0.4,2.1-0.6c3.6-0.1,6.9,0.9,9.6,3.3c0.3,0.3,0.4,0.1,0.7,0l0,0l0,0c0.7-1.5,0.1-3.1,0.3-4.8 c0.1-0.9-0.3-1.3-1-1.8c-4.5-2.4-9.1-2.5-13.9-1C4.2,4,1.5,6.1,0.9,10l0,0l0,0c-0.6,1.8-0.3,3.6,0.6,5.2l0,0 c0.3,0.9,0.9,1.6,1.6,2.4c1.8,1.9,4,3.1,6.3,4.3c3.1,1.6,6.4,3.1,8.8,5.8c0.6,1.2,0.9,2.5,0.6,3.9c-0.1,0.1-0.1,0.4-0.3,0.6l0,0 c-1.6,1.8-3.7,2.4-6,2.4c-4,0-7.5-1.6-10.3-4.5C2,30,1.8,29.5,1.4,29.8c-0.3,0.1-0.3,0.6-0.3,0.9c0,1.5,0,3,0,4.5 c0,0.9,0.3,1.5,1.2,1.9c3.7,2.1,7.6,3,11.8,2.7c4.6-0.3,8.5-2.1,10.5-6.9c1-2.4,0.9-4.8-0.1-7C23.1,22.6,20.3,20.8,17.3,19.3z"
      />
      <path
        fill="currentColor"
        d="M54.6,22.8c-0.4,0.6-1.2,1.3-1.8,1.8c-0.6,0.6-0.4,0.4-1,1c-0.3,0.3-0.4,0.4-1.2,1.2c0,1.9-0.9,4.5-2.2,5.8 c-0.7,0.7-1.6,1.3-2.7,1.8c-2.2,0.7-4.6,1.2-6.7-0.4c2.2-2.1,4.3-4.2,6.4-6.4c2.2-1.9,4.3-4.2,6.4-6.4l0,0l0,0 c0.4-0.6,0.6-0.7,1.3-1.6c-6.3-8.2-17.8-6.7-21.9,1c-1.6,2.5-2.1,5.4-1.8,8.4c0.1,0.7,0.1,1.5,0.4,2.4c1-1,2.1-1.9,2.7-2.4 c0.6-0.7,1-0.9,2.2-2.2c-0.1-2.2,0.6-4.2,1.5-5.1c1.5-1.5,3.6-2.5,5.8-2.4c0.9,0,1.8,0.3,2.7,0.6c1,0.1,0.9,0.6,0.3,1.3 c-1.8,1.8-3.6,3.7-5.4,5.5c-2.1,1.9-4.2,3.9-6.1,6.1c-0.3,0.1-1.9,1.9-2.1,2.1c0.4,0.6,0.6,0.7,1.3,1.5c2.7,2.7,6,4.2,9.7,3.9 c4.8-0.3,8.5-2.4,10.9-6.7c1.6-2.4,1.9-5.1,1.6-7.9C55.2,24.6,54.9,23.5,54.6,22.8z"
      />
      <circle fill="currentColor" cx="53.4" cy="4" r="3.6" />
    </svg>
  );
}
